import { themes } from '@lokalise/louis';

import { generateThemeColors, palette } from '../colors';
import zIndices from '../zIndices/zIndices.json'; // eslint-disable-line import/extensions

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const breakpoints: any = ['768px', '992px', '1200px', '1500px', '1800px'];
const [sm, md, lg, xlg, xxlg] = breakpoints;
breakpoints.sm = sm;
breakpoints.md = md;
breakpoints.lg = lg;
breakpoints.xlg = xlg;
breakpoints.xxlg = xxlg;

const boxShadow = {
    1: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    2: '0px 0px 12px rgba(0, 0, 0, 0.2)',
};

const colors = generateThemeColors(palette, 'light');

export default {
    ...themes.base,
    colors,
    breakpoints,
    zIndices,
    boxShadow,
};
